import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard, MdShield } from "react-icons/md";
import Widget from "components/widget/Widget";
import userResources from "api/userResources";
import { useEffect, useState } from "react";
import { IoMdAirplane } from "react-icons/io";
import { FaGlobeAsia, FaHotel, FaMapMarkedAlt, FaShip } from "react-icons/fa";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../redux/userSlice";
const Dashboard = ({
  ProfileData,
  ProfileModalData,
  profileModalClassName,
  assignListNavigate,
  createdListNavigate,
  hotelprofileData,
  hotelassignListNavigate,
  hotelcreatedListNavigate,
  otherserviceprofileData,
  otherserviceassignListNavigate,
  otherservicecreatedListNavigate,
}) => {
  const userInfo = useSelector(selectUserInfo);
  const superAdminRole = Number(process.env.REACT_APP_ROLE_SUPERADMIN);

  // animation
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Delay between child animations
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <div>
      {/* Card widget */}
      <div>
        <h1 className="mt-2 text-lg font-semibold text-gray-900 dark:text-[#ff4e41]">
          CRM statistics
        </h1>
        <motion.div
          className={`mt-3 ${
            profileModalClassName
              ? "grid-col-1 grid gap-y-2 p-3"
              : "grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
          }`}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={itemVariants}>
            <Widget
              heading={"Flight"}
              icon={
                <IoMdAirplane className="h-7 w-7 text-purple-500 dark:text-white" />
              }
              // title={"Total Enquiries"}
              // subtitle={`${data?.totalEnquiries || 0}`}
              cardbgColor="bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 cursor-pointer"
              titleColor={"text-gray-900 dark:text-white"}
              navigateTo={"/admin/flight-statistics"}
              assignListNavigate={assignListNavigate}
              createdListNavigate={createdListNavigate}
              data={ProfileData ? ProfileData : ProfileModalData}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <Widget
              heading={"Hotel"}
              icon={
                <FaHotel className="h-7 w-7 text-green-500 dark:text-white" />
              }
              // title={"Total Enquiries"}
              // subtitle={`${data?.totalEnquiries || 0}`}
              cardbgColor="bg-gradient-to-r from-green-400 via-green-500 to-green-600 cursor-pointer"
              titleColor={"text-gray-900 dark:text-white"}
              navigateTo={"/admin/hotel-statistics"}
              assignListNavigate={hotelassignListNavigate}
              createdListNavigate={hotelcreatedListNavigate}
              data={hotelprofileData ? hotelprofileData : ProfileModalData}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <Widget
              heading={"Other Service"}
              icon={
                <FaMapMarkedAlt className="h-7 w-7 text-red-500 dark:text-white" />
              }
              // title={"Total Enquiries"}
              // subtitle={`${data?.totalEnquiries || 0}`}
              cardbgColor="bg-gradient-to-r from-red-400 via-red-500 to-red-600 cursor-pointer"
              titleColor={"text-gray-900 dark:text-white"}
              navigateTo={"/admin/other-service-statistics"}
              assignListNavigate={otherserviceassignListNavigate}
              createdListNavigate={otherservicecreatedListNavigate}
              data={
                otherserviceprofileData
                  ? otherserviceprofileData
                  : ProfileModalData
              }
            />
          </motion.div>
        </motion.div>
      </div>
      {userInfo?.data?.role_id === superAdminRole && (
        <div>
          <h1 className="mt-2 text-lg font-semibold text-gray-900 dark:text-[#ff4e41]">
            Invoice statistics
          </h1>
          <motion.div
            className={`mt-3 ${
              profileModalClassName
                ? "grid-col-1 grid gap-y-2 p-3"
                : "grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
            }`}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.div variants={itemVariants}>
              <Widget
                heading={"Air Ticket"}
                icon={
                  <IoMdAirplane className="h-7 w-7 text-red-500 dark:text-white" />
                }
                // subtitle={`${data?.totalEnquiries || 0}`}
                cardbgColor="bg-gradient-to-r from-red-400 via-red-500 to-red-600 cursor-pointer"
                titleColor={"text-gray-900 dark:text-white"}
                navigateTo={"/admin/invoice-statistics"}
                data={{ airticket: true }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <Widget
                heading={"Insurance"}
                icon={
                  <MdShield className="h-7 w-7 text-pink-500 dark:text-white" />
                }
                // subtitle={`${data?.totalEnquiries || 0}`}
                cardbgColor="bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 cursor-pointer"
                titleColor={"text-gray-900 dark:text-white"}
                navigateTo={"/admin/invoice-statistics"}
                data={{ insurance: true }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <Widget
                heading={"Landpackage"}
                icon={
                  <FaGlobeAsia className="h-7 w-7 text-purple-500 dark:text-white" />
                }
                // subtitle={`${data?.totalEnquiries || 0}`}
                cardbgColor="bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 cursor-pointer"
                titleColor={"text-gray-900 dark:text-white"}
                navigateTo={"/admin/invoice-statistics"}
                data={{ landPackage: true }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <Widget
                heading={"Hotel"}
                icon={
                  <FaHotel className="h-7 w-7 text-green-500 dark:text-white" />
                }
                // subtitle={`${data?.totalEnquiries || 0}`}
                cardbgColor="bg-gradient-to-r from-green-400 via-green-500 to-green-600 cursor-pointer"
                titleColor={"text-gray-900 dark:text-white"}
                navigateTo={"/admin/invoice-statistics"}
                data={{ hotel: true }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <Widget
                heading={"Cruise"}
                icon={
                  <FaShip className="h-7 w-7 text-orange-500 dark:text-white" />
                }
                // subtitle={`${data?.totalEnquiries || 0}`}
                cardbgColor="bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 cursor-pointer"
                titleColor={"text-gray-900 dark:text-white"}
                navigateTo={"/admin/invoice-statistics"}
                data={{ cruise: true }}
              />
            </motion.div>
          </motion.div>
        </div>
      )}

      {/* Charts */}
      {/* 
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div> */}

      {/* Tables & Charts */}

      {/* <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <div>
          <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div>

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard />
        </div>

        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
